import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { contactKeys } from '@/lib/queryKeys';
import type { ContactSearchResult } from '@/types/contact';

interface ContactSearchResponse {
  data: ContactSearchResult[];
  total: number;
  query: string;
}

export function useContactSearch(query: string, limit = 20, options?: { enabled?: boolean }) {
  const trimmed = query.trim();

  return useApiQuery<ContactSearchResponse>({
    queryKey: contactKeys.search(trimmed, limit),
    queryFn: () =>
      apiGet<ContactSearchResponse>(operationsClient, '/contacts/search', {
        params: { q: trimmed, limit },
      }),
    enabled: (options?.enabled ?? true) && trimmed.length >= 2,
    showErrorToast: false,
  });
}
